import { ICartItem } from '../models/ICart'
import { IAllowedPartKeyValue } from '../store/hooks/useAllowedPartsFlag'
import { getKitType, isKitSku, isPartAllowedForDifm3 } from './allowedPartsForDifm3'
import getIsDifmAllowedForVehicleFitment from './getIsDifmAllowedForVehicleFitment'

const getIsCartItemAvailableForDifm = (item: ICartItem, allowedPartsForDifmMasterFilter?: IAllowedPartKeyValue) => {
  const isVehicleFit = item.modifiers?.vehicle?.isFit
  const { isUniversal } = item.product
  const make = item.modifiers?.vehicle?.details?.make
  const vehicleAvailableForDifm = getIsDifmAllowedForVehicleFitment(Boolean(isVehicleFit), isUniversal, make)

  if (!vehicleAvailableForDifm) {
    return false
  }

  return isPartAllowedForDifm3(item.product?.part?.name, isKitSku(item.product.sku), getKitType(item.product.sku), allowedPartsForDifmMasterFilter)
}

export default getIsCartItemAvailableForDifm
